/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Card from "../../shared-ui/card";
import Slider from "react-slick";

// Interface for TipsComponent State
interface TipsComponentState {}

// Interface for TipsComponent Props
interface TipsComponentProps {
  colClassName: string;
  tipsData?: any;
  history?: any;
  cardSettings?: any;
  handleSeeMore?: (index: number, heading: string) => void;
  handleSeeMoreOnKeyPress?: (
    index: number,
    heading: string,
    event: any
  ) => void;
  //needStateImages?: any;
}

/**
 * TipsComponent component.
 *
 * @namespace TipsComponent
 */
class TipsComponent extends React.Component<
  TipsComponentProps,
  TipsComponentState
> {
  constructor(props: any) {
    super(props);
    // this.state = {
    // };
  }

  render() {
    const { colClassName, cardSettings, tipsData } = this.props;
    const splitedStr = this.props.history.location.pathname.split("/");
    const pathName = splitedStr && splitedStr.slice(1).pop();

    return (
      <>
        <div className="food-card-wrapper">
          <div className="bootstrap-wrapper">
            {/* For Mobile View Start */}
            {pathName === "results" ? (
              <div className="inner-wrapper visible-xs col-md-12 clearfix">
                <Slider {...cardSettings}>
                  {tipsData
                    ? tipsData?.map((item: any, index: number) => (
                        <div
                          className={`${colClassName} cards-wrapper pull-left`}
                          key={index}
                        >
                          <Card
                            {...this.props}
                            handleSeeMore={(heading: string) => {
                              if (this.props.handleSeeMore) {
                                this.props.handleSeeMore(index, heading);
                              }
                            }}
                            handleSeeMoreOnKeyPress={(
                              heading: string,
                              e: any
                            ) => {
                              if (this.props.handleSeeMoreOnKeyPress) {
                                this.props.handleSeeMoreOnKeyPress(
                                  index,
                                  heading,
                                  e
                                );
                              }
                            }}
                            title={item?.tip_title}
                            description={item?.what_content}
                            imageUrl={item?.what_image?.url}
                            type="tips"
                          />
                        </div>
                      ))
                    : null}
                </Slider>
              </div>
            ) : null}
            {/* For Mobile View Ends */}

            {/* For Desktop View Start */}
            <div
              className={`inner-wrapper ${
                pathName === "results" ? "visible-lg " : ""
              }`}
            >
              {/* {newArray &&
              newArray.length > 0 &&
              newArray.map((item: any) = (
                
                <div className={`${colClassName} cards-wrapper pull-left`}>
                  <Card handleSeeMore={this.props.handleSeeMore} />
                </div>;
              ))} */}
              <div className="cards-area row col-md-12 clearfix">
                {tipsData && tipsData.length > 0
                  ? //&&
                    // needStateImages &&
                    // needStateImages.length > 0
                    tipsData.map((item: any, index: number) => (
                      <div
                        className={`${colClassName} cards-wrapper pull-left`}
                        key={index}
                      >
                        <Card
                          {...this.props}
                          handleSeeMore={(heading: string) => {
                            if (this.props.handleSeeMore) {
                              this.props.handleSeeMore(index, heading);
                            }
                          }}
                          handleSeeMoreOnKeyPress={(
                            heading: string,
                            e: any
                          ) => {
                            if (this.props.handleSeeMoreOnKeyPress) {
                              this.props.handleSeeMoreOnKeyPress(
                                index,
                                heading,
                                e
                              );
                            }
                          }}
                          title={item?.tip_title}
                          description={item?.what_content}
                          imageUrl={item?.what_image?.url}
                          type="tips"
                        />
                      </div>
                    ))
                  : null}
              </div>
            </div>
            {/* For Desktop View Ends */}
          </div>
        </div>
      </>
    );
  }
}

export default TipsComponent;
